import React, { useState } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import {
    solidVariantProps,
    type SolidButtonSize,
    type SolidButtonVariant,
} from "@components/financialConnection/ConnectionActionButton";
import { Button } from "@design-system/Button/Button";
import { RemoveFinancialAccountModal } from "./RemoveFinancialAccountModal/RemoveFinancialAccountModal";

interface Props {
    account: FinancialAccount;
    variant?: Extract<
        SolidButtonVariant,
        "primary" | "secondary" | "destructive"
    >;
    size?: SolidButtonSize;
    className?: string;
    children: React.ReactNode;
}
export const RemoveFinancialAccount: React.FC<Props> = ({
    account,
    children,
    variant = "primary",
    size = "md",
    className,
}) => {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => setShowModal(false);

    return (
        <>
            <Button
                onClick={() => setShowModal(true)}
                {...solidVariantProps(variant, size)}
                className={className}
            >
                {children}
            </Button>
            <RemoveFinancialAccountModal
                showModal={showModal}
                setShowModal={setShowModal}
                account={account}
                closeModal={closeModal}
            />
        </>
    );
};
